const ATIVO_MERCADO = {
    CNT: { id: 'CNT', descricao: 'Conta', codigo: 2 ^ 0 },
    POU: { id: 'POU', descricao: 'Poupança', codigo: 2 ^ 1 },
    PRV: { id: 'PRV', descricao: 'Previdência', codigo: 2 ^ 2 },
    FND: { id: 'FND', descricao: 'Fundo de Investimento', codigo: 2 ^ 3 },
    TPU: { id: 'TPU', descricao: 'Título Público', codigo: 2 ^ 4 },
    TPR: { id: 'TPR', descricao: 'Título Privado', codigo: 2 ^ 5 },
    TBA: { id: 'TBA', descricao: 'Título Bancário', codigo: 2 ^ 6 },
    ACN: { id: 'ACN', descricao: 'Ação', codigo: 2 ^ 7 },
    FGT: { id: 'FGT', descricao: 'FGTS', codigo: 2 ^ 8 },
    DRI: { id: 'DRI', descricao: 'Derivativo', codigo: 2 ^ 9 },
    CRP: { id: 'CRP', descricao: 'Criptomoeda', codigo: 2 ^ 10 },
    IMV: { id: 'IMV', descricao: 'Imóvel', codigo: 2 ^ 11 },
    VEI: { id: 'VEI', descricao: 'Veículo', codigo: 2 ^ 12 },
    CAR: { id: 'CAR', descricao: 'Cartão', codigo: 2 ^ 13 },
    MOE: { id: 'MOE', descricao: 'Moeda Estrangeira', codigo: 2 ^ 14 },
    AGR: { id: 'AGR', descricao: 'Agronegócio', codigo: 2 ^ 15 },
    MTL: { id: 'MTL', descricao: 'Metal Nobre', codigo: 2 ^ 16 },
    PDR: { id: 'PDR', descricao: 'Pedra Preciosa', codigo: 2 ^ 17 },
    ART: { id: 'ART', descricao: 'Obra de Arte', codigo: 2 ^ 18 },
    FDL: { id: 'FDL', descricao: 'Programa de Fidelidade', codigo: 2 ^ 19 },
    SEG: { id: 'SEG', descricao: 'Seguro', codigo: 2 ^ 20 },
    BEM: { id: 'BEM', descricao: 'Outros Ativos', codigo: 2 ^ 21 },
    CBL: { id: 'CBL', descricao: 'Contábil', codigo: 2 ^ 22 }
    // ETF: { id: 'ETF', descricao: 'ETF', codigo: 2 ^ 23 }
};

module.exports = ATIVO_MERCADO;
